module.exports = __webpack_public_path__ + "static/media/logo_tech_Prancheta.9c59d3da.png";